import * as types from '../constants';

export const initBuildingListState = () => ({
  type: types.INIT_BUILDING_LIST_STATE,
});

export const setBuildingList = buildingList => ({
  type: types.SET_BUILDING_LIST,
  payload: buildingList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_BUILDING_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_BUILDING_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_BUILDING_FILTER_ITEM,
  payload: filterItem
});